import { ref } from 'vue'
import { usePlanningStore } from '@/stores/planning.store'
import { useAllocationConfirm } from '@/composables/allocation-confirm'

// Confirming a movement also aligns its scheduled_at to the execution time (backend),
// so the goods become available immediately. Warn the user before proceeding.
export function useWarehouseMovementConfirm(refreshAsync) {
  const planningStore = usePlanningStore()
  const { noStockDialog, runConfirmAsync } = useAllocationConfirm()
  const showConfirm = ref(false)
  const pendingId = ref(null)

  const requestConfirm = (id) => {
    pendingId.value = id
    showConfirm.value = true
  }

  const onConfirmProceed = async() => {
    const id = pendingId.value
    pendingId.value = null
    if (id == null) return
    await runConfirmAsync(
      (force) => planningStore.confirmWarehouseMovementAsync(id, force, { skipErrorMessage: true }),
      refreshAsync,
    )
  }

  const onConfirmCancel = () => { pendingId.value = null }

  return { showConfirm, requestConfirm, onConfirmProceed, onConfirmCancel, noStockDialog }
}
